/** 生成画布元素 id（避免测试环境 uuid ESM 问题） */
export function createDesignerObjectId() {
  return `obj-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
